import { render, staticRenderFns } from "./AccrualsEstimateDetailPanel.vue?vue&type=template&id=0af2deed&scoped=true"
import script from "./AccrualsEstimateDetailPanel.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimateDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimateDetailPanel.vue?vue&type=style&index=0&id=0af2deed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2deed",
  null
  
)

export default component.exports